module.exports = __webpack_public_path__ + "static/media/media-dashboard-icon.e8deed42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/media-dashboard-icon.svg
// module id = 1518
// module chunks = 1